import { whatsappLink } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";

export default function FooterSection() {
  const currentYear = new Date().getFullYear();

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative bg-llk-dark text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <ScrollReveal className="lg:col-span-1">
            <div>
              <img
                src="https://storage.readdy-site.link/project_files/08db1482-e90f-40f7-90d7-cbafb5b2411e/2a5433d9-3529-4838-8200-c8b0b3cd71e9_LLK-Consultoria-e-Assessoria-de-Negcios-e-Agronegcios.png?v=23a7466bd496da27209b724fc2467f6f"
                alt="LLK Consultoria"
                className="h-12 w-auto object-contain mb-5 brightness-0 invert"
              />
              <p className="text-white/60 text-sm leading-relaxed mb-6">
                A LLK atua com soluções biológicas, consultoria técnica e estratégias para o desenvolvimento sustentável e produtivo do agronegócio.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-llk-gold hover:border-llk-gold transition-all"
                >
                  <i className="ri-whatsapp-line text-lg" />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-llk-gold hover:border-llk-gold transition-all"
                >
                  <i className="ri-instagram-line text-lg" />
                </a>
              </div>
            </div>
          </ScrollReveal>

          {/* Links Rápidos */}
          <ScrollReveal delay={0.1}>
            <div>
              <h4 className="text-xs font-semibold tracking-wider uppercase text-white/40 mb-5">
                Navegação
              </h4>
              <ul className="space-y-3">
                {[
                  { label: "Soluções", href: "#solucao" },
                  { label: "Produtos", href: "#produtos" },
                  { label: "Fases", href: "#fases" },
                  { label: "Contato", href: "#contato" },
                ].map((link) => (
                  <li key={link.href}>
                    <button
                      onClick={() => scrollTo(link.href)}
                      className="text-white/60 text-sm hover:text-llk-gold transition-colors cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          {/* Produtos */}
          <ScrollReveal delay={0.2}>
            <div>
              <h4 className="text-xs font-semibold tracking-wider uppercase text-white/40 mb-5">
                Produtos
              </h4>
              <ul className="space-y-3">
                {["Scudo Prime", "Predador Prime", "Bio Turbo", "Bio Blend"].map((product) => (
                  <li key={product}>
                    <span className="text-white/60 text-sm">{product}</span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          {/* Contato */}
          <ScrollReveal delay={0.3}>
            <div>
              <h4 className="text-xs font-semibold tracking-wider uppercase text-white/40 mb-5">
                Contato
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-whatsapp-line text-llk-gold mt-0.5" />
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-llk-gold transition-colors"
                  >
                    WhatsApp Business
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-llk-gold mt-0.5" />
                  <span className="text-white/60 text-sm">contato@llkconsultoria.com.br</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-2-line text-llk-gold mt-0.5" />
                  <span className="text-white/60 text-sm">Atuação em todo o Brasil</span>
                </li>
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {currentYear} LLK Consultoria e Assessoria de Negócios e Agronegócios. Todos os direitos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Atendimento consultivo. Resultados podem variar conforme manejo e condições edafoclimáticas.
          </p>
        </div>
      </div>
    </footer>
  );
}